import { render, staticRenderFns } from "./mrc_ess_iconGroup.vue?vue&type=template&id=9aaab95a&scoped=true&"
import script from "./mrc_ess_iconGroup.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_iconGroup.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_iconGroup.vue?vue&type=style&index=0&id=9aaab95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaab95a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
